import { autoinject } from 'aurelia-framework';
import { PLATFORM } from 'aurelia-pal';
import { activationStrategy, RouterConfiguration, Router } from 'aurelia-router';

@autoinject
export class MeasuresApp {
	constructor(private router: Router) { }

	configureRouter(config: RouterConfiguration, router: Router) {
		config.options.pushState = true;

		config.map([
			{
				route: '/admin/measures/list',
				name: 'measures-list',
				moduleId: PLATFORM.moduleName('./modules/measures-list'),
				activationStrategy: activationStrategy.invokeLifecycle,
				settings: {
					links: [{
						title: 'Administration_Measures_Button_CreateNew',
						route:  { name: 'measure-create' }
					}]
				}
			},
			{
				route: '/admin/measures/:measureId/edit',
				name: 'measure-edit',
				moduleId: PLATFORM.moduleName('./modules/measure-edit'),
				activationStrategy: activationStrategy.invokeLifecycle,
				settings: {
					links: [{
						title: 'Administration_Measures_Button_BackToList',
						route:  { name: 'measures-list' },
						isBackButton: true
					}]
				}
			},
			{
				route: '/admin/measures/create',
				name: 'measure-create',
				moduleId: PLATFORM.moduleName('./modules/measure-create'),
				activationStrategy: activationStrategy.invokeLifecycle,
				settings: {
					links: [{
						title: 'Administration_Measures_Button_BackToList',
						route:  { name: 'measures-list' },
						isBackButton: true
					}]
				}
			},
			{
				route: '/admin/measures/',
				redirect: '/admin/measures/list'
			}
		]);
	}
}
